import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import '../UserAgreement/style.scss';

interface UserAgreementProps {
  payPhone?: boolean;
}

const GoodpayUserAgreement: FC<UserAgreementProps> = () => {
  const { t } = useTranslation();

  return (
    <div className="user-agreement">
      <p className="user-agreement__text">
        {t('common:take_btn')} {`"${t('common:confirm')}"`}, вы принимаете
        условия &nbsp;
        <a
          href="/goodpay-public-ofert.pdf"
          download
          className="user-agreement__link"
        >
          {t('common:oferta')}
        </a>
      </p>
    </div>
  );
};

export default GoodpayUserAgreement;
